import { css } from "styled-components";

export const contentStyles = css`
    &.aevi-content {
        width: calc(100% - 270px);
        height: calc(100vh - 60px);
        overflow-x: hidden;
        overflow-y: auto;
        margin-top: 60px;
        margin-left: 270px;
        padding: 30px;
        display: flex;
        flex-direction: column;
    }

    @media screen and (max-width: 960px) {
        &.aevi-content {
            margin-left: 50px;
            width: calc(100% - 50px);
        }
    }
`;
